import React, { useEffect, useState } from 'react';
import { DashboardStyle, LanguageStyle, PopupStyle } from '../components/templates/_style';
import { useRecoilState } from 'recoil';
import { constructionInfoState } from '../store/Atoms';
import { escKeyModalClose } from '../util/global';
import { useTranslation } from 'react-i18next';

const PopupSiteInfo = ({ onClose }: { onClose: (key: 'siteInfo') => void }) => {
  const [info] = useRecoilState(constructionInfoState);
  const { t } = useTranslation();
  const [boxState, setBoxState] = useState({
    owner: false,
    contractor: false,
    subContractor: false,
  });
  const onBoxOnOff = (str: 'owner' | 'contractor' | 'subContractor') => {
    setBoxState({ ...boxState, [str]: !boxState[str] });
  };
  useEffect(() => {
    window.addEventListener('keydown', (e) => escKeyModalClose(e, () => onClose('siteInfo')));
    return () => window.removeEventListener('keydown', (e) => escKeyModalClose(e, () => onClose('siteInfo')));
  }, []);
  return (
    <>
      <PopupStyle.Dimmed></PopupStyle.Dimmed>
      <PopupStyle.Popup $width={400}>
        <PopupStyle.Head $height={48} $align={'left'}>
          <PopupStyle.Title>{t('현장정보')}</PopupStyle.Title>
          <PopupStyle.CloseBtn $right={12} type={'button'} onClick={() => onClose('siteInfo')}></PopupStyle.CloseBtn>
        </PopupStyle.Head>
        <PopupStyle.Cont>
          <PopupStyle.Inner $padding={'20px 24px'}>
            <DashboardStyle.InfoItem>
              <strong>{t('사업명')}</strong>
              <p dangerouslySetInnerHTML={{ __html: info.projectName.replace('.', '<br>') }}>{}</p>
            </DashboardStyle.InfoItem>
            <DashboardStyle.InfoItem>
              <DashboardStyle.InfoTitleRow>
                <strong>{t('발주처')}</strong>
                <button type={'button'} className={boxState.owner ? 'active' : undefined} onClick={() => onBoxOnOff('owner')}>
                  <span className={'hidden'}>보이기/숨기기</span>
                </button>
              </DashboardStyle.InfoTitleRow>
              {info.owner.map((i, index) => {
                return (
                  <DashboardStyle.InfoBoxGroup key={index} className={boxState.owner ? 'active' : undefined}>
                    <p>{i.companyName}</p>
                    <DashboardStyle.InfoBox className={boxState.owner ? 'active' : undefined}>
                      <DashboardStyle.InfoRow>
                        <b>{t('담당자')}</b>
                        <span>{i.companyManager}</span>
                      </DashboardStyle.InfoRow>
                      <DashboardStyle.InfoRow>
                        <b>{t('연락처')}</b>
                        <ul>
                          <li>{i.officeNumber}</li>
                          <li>{i.phoneNumber}</li>
                        </ul>
                      </DashboardStyle.InfoRow>
                      <DashboardStyle.InfoRow>
                        <b>{t('이메일')}</b>
                        <span>{i.email}</span>
                      </DashboardStyle.InfoRow>
                    </DashboardStyle.InfoBox>
                  </DashboardStyle.InfoBoxGroup>
                );
              })}
            </DashboardStyle.InfoItem>
            <DashboardStyle.InfoItem>
              <DashboardStyle.InfoTitleRow>
                <strong>{t('시공사')}</strong>
                <button type={'button'} className={boxState.contractor ? 'active' : undefined} onClick={() => onBoxOnOff('contractor')}>
                  <span className={'hidden'}>보이기/숨기기</span>
                </button>
              </DashboardStyle.InfoTitleRow>
              {info.contractor.map((i, index) => {
                return (
                  <DashboardStyle.InfoBoxGroup key={index} className={boxState.contractor ? 'active' : undefined}>
                    <p>{i.companyName}</p>
                    <DashboardStyle.InfoBox className={boxState.contractor ? 'active' : undefined}>
                      <DashboardStyle.InfoRow>
                        <b>{t('담당자')}</b>
                        <span>{i.companyManager}</span>
                      </DashboardStyle.InfoRow>
                      <DashboardStyle.InfoRow>
                        <b>{t('연락처')}</b>
                        <ul>
                          <li>{i.officeNumber}</li>
                          <li>{i.phoneNumber}</li>
                        </ul>
                      </DashboardStyle.InfoRow>
                      <DashboardStyle.InfoRow>
                        <b>{t('이메일')}</b>
                        <span>{i.email}</span>
                      </DashboardStyle.InfoRow>
                    </DashboardStyle.InfoBox>
                  </DashboardStyle.InfoBoxGroup>
                );
              })}
            </DashboardStyle.InfoItem>
            <DashboardStyle.InfoItem>
              <DashboardStyle.InfoTitleRow>
                <strong>{t('용역사')}</strong>
                <button type={'button'} className={boxState.subContractor ? 'active' : undefined} onClick={() => onBoxOnOff('subContractor')}>
                  <span className={'hidden'}>보이기/숨기기</span>
                </button>
              </DashboardStyle.InfoTitleRow>
              {info.subContractor.map((i, index) => {
                return (
                  <DashboardStyle.InfoBoxGroup key={index} className={boxState.subContractor ? 'active' : undefined}>
                    <p>{i.companyName}</p>
                    <DashboardStyle.InfoBox className={boxState.subContractor ? 'active' : undefined}>
                      <DashboardStyle.InfoRow>
                        <b>{t('담당자')}</b>
                        <span>{i.companyManager}</span>
                      </DashboardStyle.InfoRow>
                      <DashboardStyle.InfoRow>
                        <b>{t('연락처')}</b>
                        <ul>
                          <li>{i.officeNumber}</li>
                          <li>{i.phoneNumber}</li>
                        </ul>
                      </DashboardStyle.InfoRow>
                      <DashboardStyle.InfoRow>
                        <b>{t('이메일')}</b>
                        <span>{i.email}</span>
                      </DashboardStyle.InfoRow>
                    </DashboardStyle.InfoBox>
                  </DashboardStyle.InfoBoxGroup>
                );
              })}
            </DashboardStyle.InfoItem>
            <DashboardStyle.InfoItem>
              <strong>{t('주소')}</strong>
              <p>{info.address}</p>
            </DashboardStyle.InfoItem>
          </PopupStyle.Inner>
        </PopupStyle.Cont>
      </PopupStyle.Popup>
    </>
  );
};

export default PopupSiteInfo;
